import { t } from 'ttag'
import { v4 as uuidv4 } from 'uuid'

import { CopyIcon, Edit3Icon, Trash2Icon } from 'components/shared/Icon/model'

export const ACTION_COPY = 'ACTION_COPY'
export const ACTION_DELETE = 'ACTION_DELETE'
export const ACTION_EDIT = 'ACTION_EDIT'

export const getColumns = () => [
  // TOOD: uncomment when BE is ready with sorting
  { header: t`name`, alignLeft: true /*accessorKey: 'name'*/ },
  { header: t`department` },
  { header: t`languages` },
  { header: t`ability test` },
  { header: t`personality test` },
  { header: t`interview` },
  { header: '', id: uuidv4() },
]

export const getRowActions = () => [
  { icon: Edit3Icon, label: t`Edit`, type: ACTION_EDIT },
  { icon: CopyIcon, label: t`Copy`, type: ACTION_COPY },
  { icon: Trash2Icon, label: t`Remove`, type: ACTION_DELETE },
]
